import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';
import SizeDisplay from '../../../Common/Measurements/SizeDisplay';

const PRODUCT_ID = 47;
const VIEW_PRODUCT_ID = 29;

export default function ShortsPage() {
  const [t] = useTranslation('page/products/shorts');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Shorts | Products')}
      description={t('Design and create your own custom printed Shorts featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#ebabd5"
      bgStyle={{
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '47%',
      }}
      tag={t('The all-over print')}
      title={t('Shorts')}
      text={<Trans
        t={t}
        i18nKey={tKey('Encourage high energy workouts with custom all-over print shorts made on-demand in Montreal, Canada. Featuring a low-rise silhouette, foldover waistband, and a daring <inseam/> inseam, these shorts have a sleek, agile fit. Crafted from ultrasoft Luxeform fabric, they feature vivid, long-lasting prints that never fade through every move and wash.')}
        components={{
          inseam: <SizeDisplay sizes={[2.5]} sourceUnit="in" displayType="physical" />,
        }}
      />}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/shorts/banner-1-' + locale + '.png')}
      alt={t('Picture of Shorts')}
      details={[
        {
          img: require('@resources/img/pages/products/shorts/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Body-hugging fit with low-rise waist and foldover elastic. '),
        },
        {
          img: require('@resources/img/pages/products/shorts/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/shorts/icon-3.svg?url'),
          alt: t('icon'),
          text: <Trans
            t={t}
            i18nKey={tKey('<inseam/> inseam, side seam, and gusset')}
            components={{
              inseam: <SizeDisplay sizes={[2.5]} sourceUnit="in" displayType="physical" />,
            }}
          />,
        },
        {
          img: require('@resources/img/pages/products/shorts/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/shorts/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    {/*<SectionGallery images={[
      require('@resources/img/pages/products/shorts/gallery_0.jpg'),
      require('@resources/img/pages/products/shorts/gallery_1.jpg'),
      require('@resources/img/pages/products/shorts/gallery_2.jpg'),
      require('@resources/img/pages/products/shorts/gallery_3.jpg'),
      require('@resources/img/pages/products/shorts/gallery_4.jpg'),
    ]} />*/}

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Shorts<br/> <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love shorts! At prices designed for reselling, shorts made on demand meet the needs of sellers who prefer not to stock inventory.. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing productId={PRODUCT_ID} />

    <SectionSizes
      chart="bottoms"
      productId={PRODUCT_ID}
      title={t('Shorts Sizing')}
      text={t('All measurements are approximate. Since our products are made by hand, there may be variations in the finished size of our products between orders or even within an order.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Shorts')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your shorts with these great products to create your own unique styles.')}
      productSlugs={['athletic-crop-top', 'cropped-pullover-hoodie', 'flow-racerback-tank-top']}
    />
  </div>
}
